import api from './api';

/**
 * @param {string} user_id
 * @returns {Promise<{ success: boolean }>}
 */
export default async function calculateSpeakingResult(user_id) {
    const { data } = await api.post(`users/${user_id}/recalculate_speaking_results`);
    return data;
}